/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {DjPsychoGameAssets} from "./DjPsychoGameAssets";
import {DjPsychoSound} from "./sound/DjPsychoSound";
import {DjPsychoBackgroundElements} from "./view/DjPsychoBackgroundElements";
import {DjPsychoWinPresentation} from "./gameflow/DjPsychoWinPresentation";
import {DjPsychoNormalBetPresentation} from "./gameflow/DjPsychoNormalBetPresentation";
import {DjPsychoNormalResultPresentation} from "./gameflow/DjPsychoNormalResultPresentation";
import {DjPsychoIdleNormalPresentation} from "./gameflow/DjPsychoIdleNormalPresentation";
import {DjPsychoZeroBetIdlePresentation} from "./gameflow/DjPsychoZeroBetIdlePresentation";
import {ISymbolValues} from "./server/IDjPsychoData";
import {DjPsychoModel} from "./server/DjPsychoModel";
import {DjPsychoReelsView} from "./reels/DjPsychoReelsView";
import {DjPsychoGameMode} from "./server/DjPsychoGameMode";
import {DjPsychoWinView} from "./view/DjPsychoWinView";
import {DjPsychoXN} from "./view/DjPsychoXN";
import {DjPsychoXZ} from "./view/DjPsychoXZ";
import {DjPsychoXWords} from "./view/DjPsychoXWords";
import {TimelineLite} from "gsap";
import {DjPsychoIntroView} from "./view/freespin/DjPsychoIntroView";
import {DjPsychoOutroView} from "./view/freespin/DjPsychoOutroView";
import {DjPsychoBlackBgView} from "./view/DjPsychoBlackBgView";
import {DjPsychoXSymTransform} from "./view/DjPsychoXSymTransform";
import {DjPsychoXBPM} from "./view/DjPschoXBPM";
import {DjPsychoTotalWinView} from "./view/DjPsychoTotalWinView";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {DjPsychoTotalMultiplier} from "./view/DjPsychoTotalMultiplier";
import {DjPsychoMiniCollectors} from "./view/DjPsychoMiniCollectors";
import {DjPsychoWinCapView} from "./view/DjPsychoWinCapView";
import {DjPsychoBigWinView} from "./view/DjPsychoBigWinView";
import {ParticlesManager} from "./components/particles/ParticlesManager";
import {DjPsychoXKnob} from "./view/DjPsychoXKnob";
import {DjPsychoXBetView} from "./view/DjPsychoXBetView";
import {DjPsychoBonusBuy} from "./view/DjPsychoBonusBuy";
import {DjPsychoNoWinView} from "./view/DjPsychoNoWinView";
import {DjPsychoAdditionalFS} from "./view/freespin/DjPsychoAdditionalFS";
import {DjPsychoPopUpView} from "./view/DjPsychoPopUpView";
import {DjPsychoHotZone} from "./view/DjPsychoHotZone";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class DjPsycho extends SlotGame {

    public static readonly WILD_SYMBOL_NAMES: string[] = ["W", "xS", "C"];
    public static readonly SFS_BUY_FEATURE_NAME: string = "SUPER_FREESPIN";
    public static anyBonusBought: boolean;
    public static sfsBought: boolean;
    public static gradientColorLevel: string[] = ["#33cc00", "#6600ff", "#00ff99", "#ff0000", "#0066ff"];
    public static reelsNum: number;
    public static rowsNum: number;
    public static reelViewX: number;
    public static reelViewY: number;
    public static symbolWidth: number;
    public static symbolHeight: number;
    public static padding: number;
    public static buyFeatureName: string = "";
    public static model: DjPsychoModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: DjPsychoSound;
    public static backgroundElements: DjPsychoBackgroundElements;
    public static gameFlowController: GameFlowController;
    public static reelView: DjPsychoReelsView;
    public static winView: DjPsychoWinView;
    public static introView: DjPsychoIntroView;
    public static outroView: DjPsychoOutroView;
    public static blackBgView: DjPsychoBlackBgView;
    public static xNView: DjPsychoXN;
    public static xZView: DjPsychoXZ;
    public static xSymTransform: DjPsychoXSymTransform;
    public static xWords: DjPsychoXWords;
    public static xBPMView: DjPsychoXBPM;
    public static totalWinView: DjPsychoTotalWinView;
    public static totalMultiplier: DjPsychoTotalMultiplier;
    public static miniCollectors: DjPsychoMiniCollectors;
    public static winCapView: DjPsychoWinCapView;
    public static totalBigWinView: DjPsychoBigWinView;
    public static particleManager: ParticlesManager;
    public static xKnob: DjPsychoXKnob;
    public static xBetView: DjPsychoXBetView;
    public static noWinView: DjPsychoNoWinView;
    public static bonusBuy: DjPsychoBonusBuy;
    public static additionalFS: DjPsychoAdditionalFS;
    public static popUpView: DjPsychoPopUpView;
    public static hotZone: DjPsychoHotZone;
    public static isActionSpinsActive:boolean=false;

    private _defaultSymbolValues: ISymbolValues = {
        "M1": {
            "5": 25,
            "6": 30,
            "7": 35,
            "8": 45,
            "9": 60,
            "10": 125,
            "11": 250,
            "12": 500,
            "13": 750,
            "14": 1000,
            "15": 1500,
            "16": 2500,
            "17": 8000,
            "18": 10000,
            "19": 12000,
            "20": 15000
        },
        "M2": {
            "5": 20,
            "6": 25,
            "7": 30,
            "8": 35,
            "9": 55,
            "10": 110,
            "11": 200,
            "12": 400,
            "13": 600,
            "14": 800,
            "15": 1200,
            "16": 1500,
            "17": 2000,
            "18": 8000,
            "19": 10000,
            "20": 12000
        },
        "L1": {
            "5": 6,
            "6": 8,
            "7": 11,
            "8": 15,
            "9": 18,
            "10": 40,
            "11": 45,
            "12": 80,
            "13": 100,
            "14": 150,
            "15": 280,
            "16": 550,
            "17": 800,
            "18": 1500,
            "19": 2500,
            "20": 4000
        },
        "M3": {
            "5": 12,
            "6": 15,
            "7": 20,
            "8": 30,
            "9": 50,
            "10": 60,
            "11": 110,
            "12": 200,
            "13": 400,
            "14": 600,
            "15": 1000,
            "16": 1200,
            "17": 1500,
            "18": 5000,
            "19": 8000,
            "20": 10000
        },
        "L2": {
            "5": 5,
            "6": 6,
            "7": 8,
            "8": 10,
            "9": 15,
            "10": 30,
            "11": 40,
            "12": 70,
            "13": 75,
            "14": 100,
            "15": 250,
            "16": 500,
            "17": 700,
            "18": 1000,
            "19": 2000,
            "20": 3500
        },
        "M4": {
            "5": 10,
            "6": 14,
            "7": 18,
            "8": 25,
            "9": 40,
            "10": 50,
            "11": 80,
            "12": 150,
            "13": 200,
            "14": 300,
            "15": 600,
            "16": 800,
            "17": 1000,
            "18": 3000,
            "19": 5000,
            "20": 8000
        },
        "L3": {
            "5": 4,
            "6": 6,
            "7": 9,
            "8": 12,
            "9": 15,
            "10": 25,
            "11": 35,
            "12": 50,
            "13": 80,
            "14": 110,
            "15": 220,
            "16": 400,
            "17": 600,
            "18": 800,
            "19": 1800,
            "20": 3000
        },
        "M5": {
            "5": 7,
            "6": 10,
            "7": 13,
            "8": 15,
            "9": 30,
            "10": 45,
            "11": 55,
            "12": 100,
            "13": 150,
            "14": 200,
            "15": 400,
            "16": 650,
            "17": 900,
            "18": 2000,
            "19": 3000,
            "20": 5000
        },
        "L4": {
            "5": 3,
            "6": 5,
            "7": 8,
            "8": 10,
            "9": 15,
            "10": 20,
            "11": 30,
            "12": 40,
            "13": 75,
            "14": 100,
            "15": 200,
            "16": 300,
            "17": 400,
            "18": 700,
            "19": 1500,
            "20": 2500
        },
        "L5": {
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0
        }
    };
    private skinner:Skinner;



    constructor() {
        super();
        DjPsycho.reelsNum = 4;
        DjPsycho.rowsNum = 4;
        DjPsycho.reelViewX = 25;
        DjPsycho.reelViewY = 178;
        DjPsycho.symbolWidth = 126;
        DjPsycho.symbolHeight = 132;
        DjPsycho.padding = 8;
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady() : Promise<any>{
        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            //Bonus
            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            replaceMap.set("feature3", "intro_feature3.png");
            replaceMap.set("pageImage_11", "pageImage_11.jpg");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }
    public static gradient(color: string): any {
        const canvas: HTMLCanvasElement = document.createElement("canvas");
        const quality: number = 1680;
        const height: number = 1680;
        canvas.width = quality;
        canvas.height = height;
        const ctx: any = canvas.getContext("2d");
        const grd: any = ctx.createLinearGradient(0, 0, 0, quality);
        grd.addColorStop(0.2, "black");
        grd.addColorStop(1, color);
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, quality, height);
        return PIXI.Texture.from(canvas);
    }

    public static isWinBelowStake(): boolean {
        return this.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice(): number {
        const betLevel: string = DjPsycho.apiPlugin.freeBets.hasFreeBets() ? DjPsycho.apiPlugin.freeBets.getBet() : DjPsycho.apiPlugin.betLevel.getLevel();
        let price: number = DjPsycho.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.buyFeatureName) {
            for (let index: number = 0; index < DjPsycho.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DjPsycho.model.initData.featureBuyTimesBetValue[index].name === this.buyFeatureName) {
                    price *= DjPsycho.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    // to get price including boosted buy cost if applicable
    public static getCost(): number {
        const betLevel: string = DjPsycho.apiPlugin.freeBets.hasFreeBets() ? DjPsycho.apiPlugin.freeBets.getBet() : DjPsycho.apiPlugin.betLevel.getLevel();
        let price: number = DjPsycho.model.gameData?.playedBetValue || parseFloat(betLevel);
        if ("BOOSTED_BET" === this.buyFeatureName) {
            price *= (DjPsycho.apiPlugin.bonusFeatures.getFeatureDataByName(this.buyFeatureName) ? DjPsycho.apiPlugin.bonusFeatures.getFeatureDataByName(this.buyFeatureName)!.price : price);
        }
        return price;
    }

    /**
     * This is a new approach to this problem, with the focus being to really tie to the kinds of animations together to make a "gsap safe"
     * spine animation that actually follows the playHead of any parent timeline and supports other gsap features, such as reverse(), seek() etc.
     * Instead of just starting and stopping animations at different times.
     *
     * Caveat:
     * Does only set a new spine animation at beginning and end of the timeline.
     * So if you try to play the timeline from, say halfway into the animation, and this is not the already set spine animation.
     * It will play the current set spine animation. So playing animations not completely from the start or end (reverse(0)), will probably
     * cause you lots of headache.
     *
     * Easing do work. But be a bit cautious with easing that have overshoot. E.g. Back, or Elastic etc.
     * Because we are only animating the play head on the spine animation, there is no "overshoot". You cant play the animation longer than it is.
     *
     * !!! YOU NEED TO SET "autoUpdate = false" on your spine object.
     *
     *
     * @param spine PIXI.spineSpine object
     * @param trackIndex
     * @param animationName
     * @param loop
     * @param animationAlpha
     * @param mixDuration
     * @param resetOnComplete
     * @private
     */
    public static createTimelineForAnimation(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, loop: boolean, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            repeat: loop ? -1 : 0
        });

        // trying safe checks for #136
        if (!spine.spineData || !spine.state) {
            return tl;
        }

        const animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            throw new Error(`No animation named ${animationName}`);
        }

        spine.autoUpdate = false;

        const setAnimation: () => void = () => {
            // trying safe check for #136
            if (spine.state) {
                const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
                trackEntry.alpha = animationAlpha;
                trackEntry.mixDuration = mixDuration;
            }
        };

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        };

        const updateFunc: () => void = () => {
            // trying safe checks for #136
            if (spine && target) {
                const now = target.playHead;
                spine.update(now - target.prevTime);
                target.prevTime = now;
            }
        };

        tl.add(() => {
            target.prevTime = 0;
            setAnimation();
        });
        tl.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        });
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.to(target, {duration: 0.0001}); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc();
        });

        return tl;
    }

    public getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "M1",
                    "L1",
                    "M4",
                    "M5"
                ],
                [
                    "M3",
                    "M5",
                    "M1",
                    "L2"
                ],
                [
                    "L3",
                    "M2",
                    "L2",
                    "M4"
                ],
                [
                    "M2",
                    "L3",
                    "L3",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "M1",
                    "L1",
                    "M4",
                    "M5"
                ],
                [
                    "M3",
                    "M5",
                    "M1",
                    "L2"
                ],
                [
                    "L3",
                    "M2",
                    "L2",
                    "M4"
                ],
                [
                    "M2",
                    "L3",
                    "L3",
                    "L2"
                ]
            ],
            "evaluatedArea2": [
                [
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "betClusterWins": [],
            "thisSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "totalSpinRoundWinnings": 0,
            "wasFeatureBuy": false,
            "brokeBank": false,
            "currentMultiplier": 1,
            "addedNumberOfFreespinsThisSpin": 0,
            "colorMults": [
                1,
                1,
                1,
                1,
                1
            ],
            "colorMultsAfterCollapse": [
                1,
                1,
                1,
                1,
                1
            ],
            "listOfMergePositions": [],
            "activeColorsForFS": [
                false,
                true,
                false,
                false,
                true
            ],
            "positionForExtraFeature": -1
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            DjPsycho.model = new DjPsychoModel(SlotGame.apiPlugin, true);
            DjPsycho.gameFlowController = new GameFlowController(SlotGame.apiPlugin, DjPsycho.model);
            DjPsycho.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const winPres = new DjPsychoWinPresentation();
            const idleNormal = new DjPsychoIdleNormalPresentation();
            const reelStart = new DjPsychoNormalBetPresentation();
            const result = new DjPsychoNormalResultPresentation();
            const zeroBetIdle = new DjPsychoZeroBetIdlePresentation();

            DjPsycho.gameFlowController.addGameModeFlowStatePresentationMap(DjPsychoGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, result],
                [FlowState.WIN, winPres]
            ]));
            DjPsycho.gameFlowController.addGameModeFlowStatePresentationMap(DjPsychoGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, result],
                [FlowState.WIN, winPres]
            ]));
            DjPsycho.gameFlowController.addGameModeFlowStatePresentationMap(DjPsychoGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, result],
                [FlowState.WIN, winPres]
            ]));
            DjPsycho.gameFlowController.addGameModeFlowStatePresentationMap(DjPsychoGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, result],
                [FlowState.WIN, winPres]
            ]));
            DjPsycho.gameFlowController.addGameModeFlowStatePresentationMap(DjPsychoGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, result],
                [FlowState.WIN, winPres]
            ]));
            DjPsycho.gameFlowController.addGameModeFlowStatePresentationMap(DjPsychoGameMode.FREESPIN_SUPER_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, result],
                [FlowState.WIN, winPres]
            ]));
            this.handleSweepInit();
            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {
            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(DjPsychoGameAssets.RESOURCES_GROUPS);
            DjPsycho.assetLoader = new AssetLoader(DjPsycho.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), DjPsycho.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);

            return promises.then(() => {
                this.createViewsAndComponents();

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            DjPsycho.gameFlowController.start();
            DjPsycho.soundPlayer.switchMusic(DjPsycho.model.data.nextMode);
            DjPsycho.popUpView.showPopUp();

            for (let ctr: number = 0; ctr < (DjPsycho.rowsNum + 1); ctr++) {
                DjPsycho.miniCollectors.activateColorIndicators(ctr, false);
            }
            DjPsycho.miniCollectors.activateTexts();
            DjPsycho.miniCollectors.burnCollectorsInSFS();

            DjPsycho.totalMultiplier.setMultiplierInstantly(DjPsycho.model.initData.currentMultiplier);

            // #54
            if (DjPsycho.model.isRestore) {
                DjPsycho.model.initData.secondReels.forEach((reel: string[], reelId: number) => {
                    reel.forEach((val: string, symId: number) => {
                        if (val && val !== "X") {
                            if (val === "W") {
                                DjPsycho.reelView.getVisibleSymbolAt(reelId, symId).updateTexture(val);
                            } else {
                                DjPsycho.reelView.getVisibleSymbolAt(reelId, symId).doSymbolDouble(val, reelId, symId, false);
                            }
                        }
                    });
                });
            }

            return value;
        });
    }

    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "screens/images/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
            if (DjPsycho.model.initData.symbolValues) {
                symbolDataValueData = DjPsycho.model.initData.symbolValues;
                Logger.logDev("Using symbolValues from INIT data");
            } else {
                Logger.logDev("Using default symbolValues");
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            for (let key in symbolDataValueData) {
                paytableString = paytableString.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]));
            }
            resolve(paytableString);
        });
    }

    private getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span style="margin-left: 1.75em" class="number">40+</span>
                    <span style="margin-left: 0.1em"  class="multiplier" data-multiplier="${data[20] * 0.05}">${data[20] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.85em" class="number">37-39</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[19] * 0.05}">${data[19] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">34-36</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[18] * 0.05}">${data[18] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">31-33</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[17] * 0.05}">${data[17] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">28-30</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[16] * 0.05}">${data[16] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">25-27</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[15] * 0.05}">${data[15] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">22-24</span>
                    <span style="margin-left: 0.1em"  class="multiplier" data-multiplier="${data[14] * 0.05}">${data[14] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">19-21</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[13] * 0.05}">${data[13] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">16-18</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[12] * 0.05}">${data[12] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em ;padding-right:0.6em" class="number">13-15</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[11] * 0.05}">${data[11] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 0.75em;padding-right:0.6em" class="number">10-12</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[10] * 0.05}">${data[10] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">9</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[9] * 0.05}">${data[9] * 0.05}</span>
                </div>
                <div class="payout">
                    <span  style="margin-left: 2.38em ;padding-right:1em" class="number">8</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[8] * 0.05}">${data[8] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">7</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[7] * 0.05}">${data[7] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">6</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">5</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">4</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">3</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    private createViewsAndComponents(): void {
        //Non views
        DjPsycho.soundPlayer = new DjPsychoSound();
        DjPsycho.particleManager = new ParticlesManager();

        //Static views

        DjPsycho.winView = new DjPsychoWinView();
        DjPsycho.reelView = new DjPsychoReelsView();
        DjPsycho.backgroundElements = new DjPsychoBackgroundElements();
        DjPsycho.introView = new DjPsychoIntroView();
        DjPsycho.outroView = new DjPsychoOutroView();
        DjPsycho.blackBgView = new DjPsychoBlackBgView();
        DjPsycho.xNView = new DjPsychoXN();
        DjPsycho.xZView = new DjPsychoXZ();
        DjPsycho.xSymTransform = new DjPsychoXSymTransform();
        DjPsycho.xWords = new DjPsychoXWords();
        DjPsycho.xBPMView = new DjPsychoXBPM();
        DjPsycho.totalWinView = new DjPsychoTotalWinView();
        DjPsycho.totalMultiplier = new DjPsychoTotalMultiplier();
        DjPsycho.miniCollectors = new DjPsychoMiniCollectors();
        DjPsycho.winCapView = new DjPsychoWinCapView();
        DjPsycho.totalBigWinView = new DjPsychoBigWinView();
        DjPsycho.xKnob = new DjPsychoXKnob();
        DjPsycho.popUpView = new DjPsychoPopUpView();
        DjPsycho.xBetView = new DjPsychoXBetView();
        DjPsycho.noWinView = new DjPsychoNoWinView();
        DjPsycho.bonusBuy = new DjPsychoBonusBuy();
        DjPsycho.additionalFS = new DjPsychoAdditionalFS();
        DjPsycho.hotZone = new DjPsychoHotZone();
        DjPsycho.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE,(data:any)=>{
            if (data === true){
                DjPsycho.isActionSpinsActive = true;
            } else {
                DjPsycho.isActionSpinsActive = false;
            }

            // if (DjPsycho.apiPlugin.betHandler.betBoostData != undefined){
            //     DjPsycho.xBetView.enableButton(true);
            // } else {
            //     DjPsycho.xBetView.enableButton(false);
            // }

        });

        // NolimitApplication.addLayerAt(DjPsycho.popUpView.name, DjPsycho.popUpView, 0);
        NolimitApplication.addLayerAt(DjPsycho.noWinView.name, DjPsycho.noWinView, 0);
        NolimitApplication.addLayerAt(DjPsycho.totalBigWinView.name, DjPsycho.totalBigWinView, 0);
        NolimitApplication.addLayerAt(DjPsycho.winCapView.name, DjPsycho.winCapView, 0);
        NolimitApplication.addLayerAt(DjPsycho.totalWinView.name, DjPsycho.totalWinView, 0);
        NolimitApplication.addLayerAt(DjPsycho.introView.name, DjPsycho.introView, 0);
        NolimitApplication.addLayerAt(DjPsycho.outroView.name, DjPsycho.outroView, 0);
        NolimitApplication.addLayerAt(DjPsycho.additionalFS.name, DjPsycho.additionalFS, 0);
        NolimitApplication.addLayerAt(DjPsycho.hotZone.name, DjPsycho.hotZone, 0);
        NolimitApplication.addLayerAt(DjPsycho.winView.name, DjPsycho.winView, 0);
        NolimitApplication.addLayerAt(DjPsycho.xBPMView.name, DjPsycho.xBPMView, 0);
        NolimitApplication.addLayerAt(DjPsycho.xWords.name, DjPsycho.xWords, 0);
        NolimitApplication.addLayerAt(DjPsycho.xSymTransform.name, DjPsycho.xSymTransform, 0);
        NolimitApplication.addLayerAt(DjPsycho.xZView.name, DjPsycho.xZView, 0);
        NolimitApplication.addLayerAt(DjPsycho.xNView.name, DjPsycho.xNView, 0);
        NolimitApplication.addLayerAt(DjPsycho.bonusBuy.name, DjPsycho.bonusBuy, 0);
        NolimitApplication.addLayerAt(DjPsycho.blackBgView.name, DjPsycho.blackBgView, 0);
        NolimitApplication.addLayerAt(DjPsycho.xBetView.name, DjPsycho.xBetView, 0);
        NolimitApplication.addLayerAt(DjPsycho.totalMultiplier.name, DjPsycho.totalMultiplier, 0);
        NolimitApplication.addLayerAt(DjPsycho.xKnob.name, DjPsycho.xKnob, 0);
        NolimitApplication.addLayerAt(DjPsycho.miniCollectors.name, DjPsycho.miniCollectors, 0);
        NolimitApplication.addLayerAt(DjPsycho.reelView.name, DjPsycho.reelView, 0);
        NolimitApplication.addLayerAt(DjPsycho.backgroundElements.name, DjPsycho.backgroundElements, 0);
    }
}